import { AbstractDTO } from "./abstract";
import { GenericConfig } from '@signature-it/ngx-generic/config';

declare let _: any;

export class SolrRequestOptionsDTO extends AbstractDTO {

    public static readonly GroupByFamilyField = 'GroupFamilyName_s';
    public static readonly GroupByBucketField = 'GroupFamilyName_s';

    type_i: number;
    groupId: number;
    search: string;
    pageNumber: number;
    filters = [];
    itemsPerPage: number;
    isGroupBy: boolean;
    groupByInCatalogue;
    groupByInSearch;
    isLeaf: boolean;
    familyName: string;
    sort: string;
    stats: boolean;
    statsField: string;
    facet: boolean;
    facetRange: string;
    facetRangeStart: string;
    facetRangeEnd: string;
	facetRangeGap: string;
    extraQryString: string;
    taxonomy: string;
    entityVar: string;
    product_type_s: string;
    properties: any;
    bq: string;


    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes || {};

        this.type_i = parseInt(attributes['type_i']) || 1;
        this.groupId = parseInt(attributes['groupId']) || 1;
        this.search = attributes['search'] || '';
        this.pageNumber = attributes['pageNumber'] || 1;
        this.filters = attributes['filters'] || [];
        this.itemsPerPage = attributes['itemsPerPage'] || GenericConfig.item_per_page[0];
        this.isLeaf = attributes['isLeaf'] || false;
        this.familyName = attributes['familyName'] || '';
        this.sort = attributes['sort'] || '';
        this.isGroupBy = !_.isUndefined(attributes['isGroupBy']) ? attributes['isGroupBy'] : true;
        this.groupByInCatalogue = SolrRequestOptionsDTO.GroupByFamilyField;
        this.groupByInSearch = GenericConfig.groupByProductInSearch ? '' : SolrRequestOptionsDTO.GroupByFamilyField;
        this.stats = attributes['stats'] || false;
        this.statsField = attributes['statsField'] || '';
        this.facet = attributes['facet'] || false;
        this.facetRange = attributes['facetRange'] || '';
        this.facetRangeStart = attributes['facetRangeStart'] || '';
        this.facetRangeEnd = attributes['facetRangeEnd'] || '';
        this.facetRangeGap = attributes['facetRangeGap'] || '';
        this.extraQryString = attributes['extraQryString'] || '';
        this.taxonomy = attributes['taxonomy'] || '';
        this.entityVar = attributes['entityVar'] || '';
        this.product_type_s = attributes['product_type_s'] || '';
        this.properties = attributes['properties'] || null;
        this.bq = attributes['bq'] || '';
    }
}
